export const SIDEBAR_EXPANDED_WIDTH = 232;
